import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { LocalJsonStorage } from "../../infra/http/local-json-storage";
import { LocalLoggedInUser } from "../../data/usecases/local-logged-in-user";
import Swal from "sweetalert2";
import { CustomerDatabaseStore } from "../../store/main/CustomerDatabaseStore";
import { screenNavigation } from "../../common/utils/ReportsFilters";
import { AuthTokenStore } from "../../store/main/AuthTokenStore";
import SecureStorage from "react-secure-storage";
import secureLocalStorage from "react-secure-storage";
import { getDataKeyFromLocalStorage, setDataKeyInLocalStorage } from "../../common/utils/AuthToken";
import { SECURE_APP_CODE, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../base";

const AuthPage = () => {
  const { authToken } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const jsonStorage = LocalJsonStorage.getInstance();
  const loggedInUser = new LocalLoggedInUser(jsonStorage);
  const navigate = useNavigate();
  const { decodeToken } = CustomerDatabaseStore();
  const {
    FetchDecryptAuthToken,
    fetchDecryptAuthToken,
    FetchDecryptAuthTokenState,
  } = AuthTokenStore();


  useEffect(() => {
    if (authToken && searchParams.get("baseUrl")) {
   setDataKeyInLocalStorage({
     key: SECURE_BASE_URL_KEY,
     value: searchParams.get("baseUrl") as string,
   });
      fetchDecryptedToken();
    }
  }, [authToken]);


  const fetchDecryptedToken = async () => {
    try {
      const params = {
        token: authToken,
      };
      const response = await fetchDecryptAuthToken(params);
      if (response.success) {
        const token = response.decrypted_token;
        const appCode = response.app_code;
       setDataKeyInLocalStorage({
         key: SECURE_AUTH_TOKEN_KEY,
         value: token
       });
        setDataKeyInLocalStorage({
          key: SECURE_APP_CODE,
          value: appCode,
        });
         decodeToken();
        screenNavigation(searchParams.get("type"))
          ? navigate(screenNavigation(searchParams.get("type")))
          : Swal.fire("Unknown Type", "", "error");
      } else {
       Swal.fire("Authentication Failed", "", "error");
      }
    } catch (error) {
      console.error("Error fetching decrypted token:", error);
    }
  };

  return <div></div>;
};

export default AuthPage;
